import { useScanSoundSettingsStore } from '../store/scanSoundSettingsStore';

export const resetAllScanSoundSettings = () => {
  const { resetAllSettings } = useScanSoundSettingsStore.getState();
  resetAllSettings();
};
